import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import withProp from '../../../utils/withProp'

const ListItem = styled.div`
  position: relative;
  margin-top: -1px;
  display: flex;
  padding: 1rem 1.75rem;
  ${withProp('padding')};
  transition: all 0.2s;

  &:after,
  &:before {
    content: '';
    display: block;
    position: absolute;
    border-bottom: solid 1px #aaa;
    transition: left 200ms;

    // simulate padding by starting left and right borders
    // away from edge
    left: 1.75rem;
    right: 1.75rem;
  }

  &:before {
    top: 0;
  }

  &:after {
    bottom: 0;
  }

  ${p =>
    p.noBorder &&
    `
    &:after, &:before { border: none; }
  `}

  ${p =>
    p.full &&
    `
    padding-left: 0;
    padding-right: 0;

    &:after,
    &:before {
      left: 0;
      right: 0;
    }
  `}

   ${p =>
    p.highlight &&
    `
    &:hover {
      background: ${color.AQUA_OVERLAY};
      transition: background 200ms;
      cursor: pointer;
    }
  `}

  ${p =>
    p.fancyHighlight &&
    `
    margin-left: 1.25rem;
    padding-left: 0rem;
    background-color: transparent;
    color: ${color.AQUAMARINE};
    transition: all 200ms;

    &:hover{
      background-color: ${color.AQUA_OVERLAY};
      animation-name: list-overlay-fill-x;
      color: ${color.SCOOTER};
      animation-duration: 200ms;
      animation-fill-mode: forwards;
    }

    @keyframes list-overlay-fill-x {
      0% {
        margin-left: 1.25rem;
        padding-left: 0;
      }
      100% {
        margin-left: 0;
        padding-left: 1.25rem;
      }
    }
  `}

  ${p =>
    p.active &&
    `
    margin-left: 0;
    padding-left: 1.25rem;
    background: ${color.AQUA_OVERLAY};
    color: ${color.SCOOTER};
  `}
`

export default ListItem
